import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/audible': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 199.9V253.9L320 453.9 0 254V200L320 400 640 199.9zM445.5 271.9L492.6 242.5C455.4 186.7 391.9 149.9 319.9 149.9 247.9 149.9 184.4 186.6 147.3 242.3H147.6C150.1 240 152.7 237.8 155.3 235.6 245 161.2 374.7 177.5 445.5 271.9zM225.4 290.7C242.3 278.8 261.9 272 282.8 272 317.2 272 348 290.4 369.2 319.6L414.6 291.2C393.7 261.3 359 241.7 319.8 241.7 280.9 241.7 246.4 261.1 225.4 290.7zM103.6 161.1C235.4 56.8 421.8 84.7 521.1 223.2L521.8 224.2 570.6 193.8C517.1 112.1 424.8 58.1 319.9 58.1 216.4 58.1 123.3 111.6 69.4 193.7 79.3 183.2 92.1 170.2 103.6 161.1zM570.6 193.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/audible.js
// module id = ML2o
// module chunks = 144